var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-my-projects-offer-detail-conditions-skeleton bcx-skeleton-areas",class:{'is-narrow': _setup.isNarrow}},[_vm._l((10),function(i){return _c('div',{key:i})}),_c('div',{staticClass:"c-message"}),_c('div',{staticClass:"c-message-block"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }